import { AssignUnassignButton } from '../../../../Drivers/Grid/cellRenderer';
import { DRIVER_GRID_COMMANDS } from '../../../../Drivers/Grid/constants';
import React from 'react';

class RecommendationButton extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      command: this.getCommand(props)
    };
  }

  refresh = (props) => {
    this.setState({
      command: this.getCommand(props)
    });
    return true;
  };

  getCommand = (props) => {
    return props.data.driverId ? DRIVER_GRID_COMMANDS.REASSIGN : DRIVER_GRID_COMMANDS.ASSIGN;
  };

  shouldComponentUpdate(_nextProps, nextState) {
    return this.state.command !== nextState.command;
  }

  render() {
    const { api, data, recommendedDriverId, customClass, disabled } = this.props;
    const { command } = this.state;
    return (
      <div className={customClass ?? ''}>
        <AssignUnassignButton
          variant="outlined"
          color="primary"
          disabled={disabled}
          onClick={() =>
            api.runCommand(command, {
              ...data,
              recommendedDriverId
            })
          }
          data-automationid={command}>
          {command}
        </AssignUnassignButton>
      </div>
    );
  }
}

export default RecommendationButton;
